import React from 'react'
import Navbar from './Navbar'
import AllProducts from './AllProducts'
import Footer from './Footer'



const Main = () => {
  return (
   <>
   <Navbar/>

   <AllProducts/>
   
   <Footer/>
   </>
  )
}

export default Main